var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container-fluid"},[_c('route-header',[_c('h3',[_vm._v(_vm._s(_vm.resource.name))]),_c('nav-secondary-vehicle',{attrs:{"vehicle":_vm.vehicle}})],1),_c('vehicle-dash')],1)}
var staticRenderFns = []

export { render, staticRenderFns }